// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"79px","content-container":"full-page-editor__content-container___zdZKP"};